import { CheckoutResponseError } from '../errors/CheckoutResponseError';
import { PaymentResponseError } from '../errors/PaymentResponseError';

export class ErrorHandler {
  public static readonly defaultErrorCode = 422;
  public static readonly defaultErrorMessage = 'Unknown error';

  public static getCheckoutResponseError(error: any): CheckoutResponseError {
    if (error instanceof CheckoutResponseError) {
      return error;
    }

    return new PaymentResponseError(
      error instanceof Error && error.message.length > 0 ? error.message : ErrorHandler.defaultErrorMessage,
      ErrorHandler.defaultErrorCode,
    );
  }
}
